import React from 'react';
import { TriangleAlert } from 'lucide-react';
import Button from './Button';

const messageOf = (error) => (typeof error === 'string' ? error : error?.message);

export default function ErrorState({ title, error, onRetry, className = '' }) {
  const message = messageOf(error);

  return (
    <div role="alert" className={`px-4 py-10 max-w-[72ch] ${className}`}>
      <p className="flex items-center gap-2 text-section text-ink">
        <TriangleAlert size={17} strokeWidth={2} className="shrink-0 text-crit" aria-hidden="true" />
        {title}
      </p>
      <p className="mt-1 text-body text-graphite">
        {message ? 'The server returned:' : 'The request did not complete. Check your connection and try again.'}
      </p>
      {message && (
        <p className="mt-2 px-2.5 py-1.5 rounded-control bg-paper border border-rule font-mono text-small text-ink break-words">{message}</p>
      )}
      {onRetry && (
        <div className="mt-4">
          <Button onClick={onRetry}>Try again</Button>
        </div>
      )}
    </div>
  );
}
